module.exports = __webpack_public_path__ + "img/icone.6dd6a580.png";